<iframe style="visibility: hidden;" [src]="urlSafe" class="hideDialogIframe"></iframe>
<button mat-button mat-dialog-close>Cancel</button>